var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pet-insurance-timeline"},[(_vm.items.length > 0)?_c('el-timeline',[_c('el-timeline-item'),_vm._l((_vm.items),function(item,index){return _c('el-timeline-item',{key:index,staticClass:"pet-insurance-timline-item"},[_c('PetInsuranceItem',{attrs:{"item":item}})],1)}),_c('el-timeline-item')],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }